"use client";
import { j as o } from "../../jsx-runtime-B6kdoens.js";
import { createContext as n, useContext as s } from "react";
const e = n(null), c = ({
  brand: r,
  children: t
}) => /* @__PURE__ */ o.jsx(e.Provider, { value: { brand: r }, children: t }), i = () => {
  var t;
  const r = (t = s(e)) == null ? void 0 : t.brand;
  if (!r)
    throw new Error("Attempted to access Brand before it was set.");
  return r;
};
export {
  c as BrandProvider,
  e as brandContext,
  i as useBrand
};
//# sourceMappingURL=index.js.map
